<template>
    <div id="terms-of-service">
        <h1>ChatPTS</h1>
        <h1>Términos y Condiciones de Uso</h1>
        <p>Es requisito necesario para la adquisición de los productos que se ofrecen en este sitio, que lea y acepte
            los siguientes Términos y Condiciones que a continuación se redactan. El uso de nuestros servicios así como
            la compra de nuestros productos implicará que usted ha leído y aceptado los Términos y Condiciones de Uso en
            el presente documento. Todas los productos que son ofrecidos por nuestro sitio web pudieran ser creadas,
            cobradas, enviadas o presentadas por una página web tercera y en tal caso estarían sujetas a sus propios
            Términos y Condiciones. En algunos casos, para adquirir un producto, será necesario el registro por parte
            del usuario, con ingreso de datos personales fidedignos y definición de una contraseña.</p>

        <h2>INFORMACIÓN RELEVANTE</h2>


        <p>El usuario puede elegir y cambiar la clave para su acceso de administración de la cuenta en cualquier
            momento, en caso de que se haya registrado y que sea necesario para la compra de alguno de nuestros
            productos. https://chatpts.laizquierdadiario.com/ no asume la responsabilidad en caso de que entregue dicha
            clave a terceros.</p>
        <p>Todas las compras y transacciones que se lleven a cabo por medio de este sitio web, están sujetas a un
            proceso de confirmación y verificación, el cual podría incluir la verificación del stock y disponibilidad de
            producto, validación de la forma de pago, validación de la factura (en caso de existir) y el cumplimiento de
            las condiciones requeridas por el medio de pago seleccionado. En algunos casos puede que se requiera una
            verificación por medio de correo electrónico.</p>
        <p>Los precios de los productos ofrecidos en esta Tienda Online es válido solamente en las compras realizadas en
            este sitio web.</p>

        <h2>LICENCIA</h2>

        <p>ChatPTS a través de su sitio web concede una licencia para que los usuarios utilicen los productos que son
            vendidos en este sitio web de acuerdo a los Términos y Condiciones que se describen en este documento.</p>

        <h2>USO NO AUTORIZADO</h2>
        <p>En caso de que aplique (para venta de software, templetes, u otro producto de diseño y programación) usted no
            puede colocar uno de nuestros productos, modificado o sin modificar, en un CD, sitio web o ningún otro medio
            y ofrecerlos para la redistribución o la reventa de ningún tipo.</p>

        <h2>PROPIEDAD</h2>
        <p>Usted no puede declarar propiedad intelectual o exclusiva a ninguno de nuestros productos, modificado o sin
            modificar. Todos los productos son propiedad de los proveedores del contenido. En caso de que no se
            especifique lo contrario, nuestros productos se proporcionan sin ningún tipo de garantía, expresa o
            implícita. En ningún esta compañía será responsables de ningún daño incluyendo, pero no limitado a, daños
            directos, indirectos, especiales, fortuitos o consecuentes u otras pérdidas resultantes del uso o de la
            imposibilidad de utilizar nuestros productos.</p>

        <h2>POLÍTICA DE REEMBOLSO Y GARANTÍA</h2>
        <p>En el caso de productos que sean mercancías irrevocables no-tangibles, no realizamos reembolsos después de
            que se envíe el producto, usted tiene la responsabilidad de entender antes de comprarlo. Le pedimos que lea
            cuidadosamente antes de comprarlo. Hacemos solamente excepciones con esta regla cuando la descripción no se
            ajusta al producto. Hay algunos productos que pudieran tener garantía y posibilidad de reembolso pero este
            será especificado al comprar el producto. En tales casos la garantía solo cubrirá fallas de fábrica y sólo
            se hará efectiva cuando el producto se haya usado correctamente. La garantía no cubre averías o daños
            ocasionados por uso indebido. Los términos de la garantía están asociados a fallas de fabricación y
            funcionamiento en condiciones normales de los productos y sólo se harán efectivos estos términos si el
            equipo ha sido usado correctamente. Esto incluye:
        <ul>
            <li> De acuerdo a las especificaciones técnicas indicadas para cada producto.</li>
            <li> En condiciones ambientales acorde con las especificaciones indicadas por el fabricante.</li>
            <li> En uso específico para la función con que fue diseñado de fábrica.</li>
            <li> En condiciones de operación eléctricas acorde con las especificaciones y tolerancias indicadas.</li>
        </ul>
        </p>

        <h2>COMPROBACIÓN ANTIFRAUDE</h2>

        <p>La compra del cliente puede ser aplazada para la comprobación antifraude. También puede ser suspendida por
            más
            tiempo para una investigación más rigurosa, para evitar transacciones fraudulentas.</p>

        <h2>PRIVACIDAD</h2>

        <p>Este https://chatpts.laizquierdadiario.com/ garantiza que la sevilla fc noticias información personal que
            usted
            envía cuenta con la seguridad necesaria. Los datos ingresados por usuario o en el caso de requerir una
            validación de los pedidos no serán entregados a terceros, salvo que deba ser revelada en cumplimiento a una
            orden judicial o requerimientos legales.</p>

        <p>La suscripción a boletines de correos electrónicos publicitarios es voluntaria y podría ser seleccionada al
            momento de crear su cuenta.</p>

        <p>ChatPTS reserva los derechos de cambiar o de modificar estos términos sin previo aviso.</p>
    </div>
    <div class="login-footer-2">
        <nav>
            <RouterLink :to="{ name: 'main-view' }">Inicio</RouterLink>
            <RouterLink :to="{ name: 'terms-of-service' }">Términos del Servicio</RouterLink>
            <RouterLink :to="{ name: 'privacy-policy' }">Política de Privacidad</RouterLink>
            <a target='_blank' href="https://docs.google.com/forms/d/18aMGrwHl0ZLLWMgXbXfmLqWfwyIU42wYc15WlVfU9KY/edit">Contactanos</a>
        </nav>
    </div>
</template>

<script>

export default {
    name: "ChatComponent",
    props: {
    },

    data() {
        return {
        };
    },
    watch: {

    },

    async mounted() {
    }
};
</script>

<style scoped>
#terms-of-service {
    background: #fff;
    max-width: 1200px;
    padding: 24px;
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.3);
    height: 90vh;
    overflow-y: auto;
}

#terms-of-service h1 {
    font-weight: bold;
    margin-bottom: 48px;
    text-align: center;
}

#terms-of-service h2 {
    font-weight: bold;
    margin-bottom: 24px;
    margin-top: 12px;
}

#terms-of-service p {
    margin-bottom: 24px;
}

.login-footer-2 {
    padding-top: 24px;
    padding-bottom: 24px;
    color: #f0f0f0;

}

.login-footer-2 nav>* {
    margin: 12px;
}
</style>
